import { ref } from 'vue'

export type ToastVariant = 'error' | 'info' | 'success' | 'warning'

export interface ToastItem {
  description?: string
  duration: number
  id: number
  title?: string
  variant: ToastVariant
}

export interface ToastOptions {
  description?: string
  duration?: number
  title?: string
}

const toasts = ref<ToastItem[]>([])
let seed = 0

const DEFAULT_DURATION: Record<ToastVariant, number> = {
  info: 5000,
  success: 4000,
  warning: 5000,
  error: 4500,
}

function open(variant: ToastVariant, options: string | ToastOptions): number {
  if (!import.meta.client) return -1
  const opts = typeof options === 'string' ? { description: options } : options
  const title = opts.title?.trim() || undefined
  const description = opts.description?.trim() || undefined
  const id = ++seed
  toasts.value = [
    ...toasts.value,
    {
      id,
      variant,
      title,
      description,
      duration: opts.duration ?? DEFAULT_DURATION[variant],
    },
  ]
  return id
}

function dismiss(id: number) {
  toasts.value = toasts.value.filter((t) => t.id !== id)
}

/**
 * 命令式 Toast，由 toast-container 基于 reka-ui Toast 原语渲染。
 * 在组件外（如请求拦截器）调用安全：服务端调用会被忽略。
 */
export function useToast() {
  return {
    toasts,
    dismiss,
    info: (options: string | ToastOptions) => open('info', options),
    success: (options: string | ToastOptions) => open('success', options),
    warning: (options: string | ToastOptions) => open('warning', options),
    error: (options: string | ToastOptions) => open('error', options),
  }
}
